export function createProductClient(transport) {
    return {
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * List this tenant's products, by name, optionally within one category
         *
         * Requires scope: product:read
         */
        listProducts(tenantId, catalogId, categoryId, merchantId, status, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/products`,
                query: {
                    catalogId: catalogId,
                    categoryId: categoryId,
                    merchantId: merchantId,
                    status: status,
                    limit: limit,
                    after: after,
                },
                options,
            });
        },
        /**
         * POST /v1/tenants/{tenantId}/products
         *
         * Requires scope: product:write
         */
        createProduct(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/products`,
                body,
                options,
            });
        },
        /**
         * POST /v1/tenants/{tenantId}/products/{productId}/commands
         *
         * Requires scope: product:write
         */
        transitionProduct(tenantId, productId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/products/${encodeURIComponent(productId)}/commands`,
                body,
                options,
            });
        },
        /**
         * GET /v1/tenants/{tenantId}/products/{productId}
         *
         * Requires scope: product:read
         */
        getProduct(tenantId, productId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/products/${encodeURIComponent(productId)}`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=product.js.map